module.exports = __webpack_public_path__ + "static/img/navbg.d9b9f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/navbg.png
// module id = 6CRn
// module chunks = 1